import { useState, useEffect } from 'react';
import { api } from '@/lib/api';
import type { User } from '@photobooth/types';

type UserWithoutPassword = Omit<User, 'passwordHash'>;

export function useUsers() {
  const [users, setUsers] = useState<UserWithoutPassword[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await api.users.getAll();
      if (response.success && response.data) {
        // Handle nested data structure from API client
        const usersData = (response.data as any).data || response.data;
        setUsers(Array.isArray(usersData) ? usersData : []);
      } else {
        setError('Failed to fetch users');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch users');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return {
    users,
    isLoading,
    error,
    refetch: fetchUsers,
  };
}
